import "jquery-ui/themes/base/all.css";
import "jquery-ui/ui/widgets/datepicker";
import "../WYSIWYG.css";

import { dateIsValid } from "../../../../constants";

const ActionItem = {
  // plugin name
  name: "ActionItem",

  display: "submenu",

  // add function - It is called only once when the plugin is first run.
  // This function generates HTML to append and register the event.
  // arguments - (core : core object, targetElement : clicked button element)
  add: function (core, targetElement) {
    // Registering a namespace for caching as a plugin name in the context object
    const context = core.context;
    context.actionItem = {
      textElement: null,
    };

    // Generate submenu HTML
    // Always bind "core" when calling a plugin function
    let listDiv = this.setSubmenu.call(core);

    // Input tag caching
    context.actionItem.textElement = [
      ...listDiv.getElementsByTagName("INPUT"),
      ...listDiv.getElementsByTagName("SELECT"),
    ];

    // You must bind "core" object when registering an event.
    /** add event listeners */
    listDiv
      .getElementsByTagName("BUTTON")[0]
      .addEventListener("click", this.onClick.bind(core));

    /** append html */
    targetElement.parentNode.appendChild(listDiv);

    window.$(function () {
      window.$('#duedate').focus(() =>
        window.$("#datepicker").datepicker({
          onSelect: (date) => (listDiv.querySelector("#duedate").value = date.toString()),
          dateFormat: "DD, d MM, yy",
          changeMonth: true,
          changeYear: true,
          autoclose: true
        })
      )
    });


    // @Required
    // You must add the "submenu" element using the "core.initMenuTarget" method.
    /** append target button menu */
    core.initMenuTarget(this.name, targetElement, listDiv);
  },

  setSubmenu: function () {
    const listDiv = this.util.createElement("DIV");

    let users = "";
    let agendas = "";
    const reminderChannels = `
            <option value="mail" selected>Email</option>
            <option value="sms">SMS</option>
        `;
    const reminderT_Minus = `
            <option value="- 1 day" selected>A day before due date</option>
            <option value="- 1 week">A week before due date</option>
            <option value="- 1 month">A month before due date</option>
        `;
    const assigneables = JSON.parse(sessionStorage.getItem("assigneables"));
    const storedAgendas = JSON.parse(sessionStorage.getItem('agendas'));

    Array.isArray(assigneables) && assigneables.map(
      (user) =>
        (users += `<option value="${user.id}:${user.name}:${user.is_external ? 'external': 'internal'}">${user.name}</option>`)
    );
    Array.isArray(storedAgendas) && storedAgendas.map(
      (agenda) =>
        (agendas += `<option value="${`agenda_${agenda.id}`}">${agenda.label ?? agenda.text}</option>`)
    );

    listDiv.className = "se-list-layer override";

    listDiv.innerHTML =
      "" +
      `<div class="se-list-inner se-list-align" style="width: 300px; z-index: 5; position: relative; height: 30vh;">
            <form class="se-submenu-form-group" style='width: 100%; height: 100%; padding: 10px 5px; overflow-y: scroll' onSubmit="${event => event.preventDefault()}">
                    <ul class="se-list-basic list-unstyled list-inline">
                        <li>
                            <div class="form-group form-material" data-plugin="formMaterial">
                                <label class="form-control-label">Action</label>
                                <input class="form-control" type="text" style="width: 100%; border-bottom: none; text-transform: none;" placeholder='Enter Action...' required />
                            </div>
                        </li>
                        <li>
                            <div class="form-group form-material" data-plugin="formMaterial">
                                <label class="form-control-label">Assignee</label>
                                <select class="form-control" style="width: 100%; border-bottom: none;" placeholder='Add Assignee...' required>${users}</select>
                            </div>
                        </li>
                        <li>
                            <div class="form-group form-material" data-plugin="formMaterial">
                                <label class="form-control-label">Agenda</label>
                                <select class="form-control" style="width: 100%; border-bottom: none;" placeholder='Select Agenda...' required>${agendas}</select>
                            </div>
                        </li>
                        <li>
                            <div class="form-group form-material" data-plugin="formMaterial">
                                <label class="form-control-label">Due Date</label>
                                <input class="form-control" type="text" id="duedate" style="width: 100%; border-bottom: none; text-transform: none;" placeholder='Select Due Date....' required />
                                <div id="datepicker"></div>
                            </div>
                        </li>
                        <li>
                            <div class="form-row">
                                <div class="form-group form-material col-md-8" data-plugin="formMaterial"><label class="form-control-label">Remind assignee:</label><select  id="reminder_t_minus" class="form-control" style="width: 100%; border-bottom: none;" required>${reminderT_Minus}</select></div>
                                <div class="form-group form-material col-md-4" data-plugin="formMaterial"><label class="form-control-label">Remind via:</label><select id="alert_channels" class="form-control" style="width: 100%; border-bottom: none; padding-right: inherit;" multiple required>${reminderChannels}</select></div>
                            </div>
                        </li>
                        <li class='test'>
                            <button type="submit" class="se-btn-primary se-tooltip" style="margin-top: 20px; min-width: 280px; max-width: 280px;">
                                <span>Append</span>
                                <span class="se-tooltip-inner">
                                    <span class="se-tooltip-text">Append action item</span>
                                </span>
                            </button>
                        </li>
                    </ul>
                </form>
            </div>`;

    return listDiv;
  },

  // Called after the submenu has been rendered
  on: function () {
    this.context.actionItem.textElement[0].focus();
  },

  onClick: function () {
    this.history.push(true);
    let agendaDiv = null;
    const storedSingleAgendaItemIds = JSON.parse(
      sessionStorage.getItem("singleAgendaItemIds")
    );
    const storedSingleAgendaItems = JSON.parse(
      sessionStorage.getItem("singleAgendaItems")
    );
    const storedSingleAgendaItemPositionsInMinutes = [];
    const actionItems = JSON.parse(sessionStorage.getItem("actionItems")) ?? [];

    const value = [];

    this.context.actionItem.textElement.map((element) =>
      value.push(element.value)
    );

    value[0] = value[0].length > 0 ? value[0] : null;
    value[1] =
      value[1].length > 0 && dateIsValid(new Date(value[1])) ? value[1] : null;

    for (let val of this.context.element.wysiwyg.children) {
      if (val.id) {
        if (value[3] === val.id) agendaDiv = val;
      }
    }

    const reminderChannels = window.$("#alert_channels").val();
    const reminderT_Minus = window.$("#reminder_t_minus").val();

    if (
      value[0] &&
      value[1] &&
      value[2].length > 0 &&
      value[3].length > 0 &&
      reminderChannels.length > 0
    ) {

      const actionPositionInMinutes = this.getContents().search(value[0]);

      Array.isArray(storedSingleAgendaItems) && storedSingleAgendaItems.map((item) =>
        storedSingleAgendaItemPositionsInMinutes.push(
          this.getContents().search(item)
        )
      );

      const getAgendaItem = () => {
        const itemPositions = storedSingleAgendaItemPositionsInMinutes;

        if (actionPositionInMinutes >= itemPositions[itemPositions.length - 1]) {
          return storedSingleAgendaItemIds[
            storedSingleAgendaItemIds.length === 1 ? storedSingleAgendaItemIds.length - 1 : storedSingleAgendaItemIds.length - 1
          ];
        } else {
          for (let i = 0; i < itemPositions.length; i++) {
            if (itemPositions[i] > actionPositionInMinutes) {
              const id = itemPositions[i - 1] || itemPositions[0];
              const index = itemPositions.findIndex((item) => item === id);
              return storedSingleAgendaItemIds[index];
            }
          }
        }
      };

      // Create table structure for action point
      const tableHTML = `
        <div style="margin: 20px 0;">
          <h3 style="margin-bottom: 10px; color: #333; border-bottom: 2px solid #007bff; padding-bottom: 5px;">
            <u>Action Point</u>
          </h3>
          <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-bottom: 15px; background-color: #f9f9f9;">
            <tbody>
              <tr style="border-bottom: 1px solid #ddd;">
                <td style="padding: 8px 12px; font-weight: bold; background-color: #f1f1f1; border-right: 1px solid #ddd; width: 25%;">
                  Action:
                </td>
                <td style="padding: 8px 12px; border-right: 1px solid #ddd;">
                  ${value[0]?.toString() || 'N/A'}
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #ddd;">
                <td style="padding: 8px 12px; font-weight: bold; background-color: #f1f1f1; border-right: 1px solid #ddd;">
                  Assignee:
                </td>
                <td style="padding: 8px 12px; border-right: 1px solid #ddd;">
                  ${value[2].split(":")[1]?.toString() || 'N/A'}
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #ddd;">
                <td style="padding: 8px 12px; font-weight: bold; background-color: #f1f1f1; border-right: 1px solid #ddd;">
                  Due Date:
                </td>
                <td style="padding: 8px 12px; border-right: 1px solid #ddd;">
                  ${value[1]?.toString() || 'N/A'}
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #ddd;">
                <td style="padding: 8px 12px; font-weight: bold; background-color: #f1f1f1; border-right: 1px solid #ddd;">
                  Reminder:
                </td>
                <td style="padding: 8px 12px; border-right: 1px solid #ddd;">
                  ${reminderT_Minus} via ${reminderChannels.join(', ')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      `;

      // rendering
      const template = this.util.createElement("DIV");
      if (value[0]) {
        template.setAttribute('id', `action_point:::${value[0]?.toString()}:::${value[2]?.toString()}:::${getAgendaItem()}`)
      }
      template.innerHTML = tableHTML;
      
      if (agendaDiv) {
        this.insertNode(template, agendaDiv)
      }

      // insert
      const children = template.children;
      let after, child;

      while (children[1]) {
        child = children[1];
        this.insertNode(child, after);
        after = child;
      }

      this.setRange(after, 1, after, 1);

      actionItems.push({
        agenda: getAgendaItem(),
        action: value[0]?.toString(),
        assignee: value[2]?.toString(),
        due: new Date(value[1]),
        reminderChannels: reminderChannels,
        remindT_Minus: reminderT_Minus,
      });
      sessionStorage.setItem("actionItems", JSON.stringify(actionItems));

      // clear content
      this.context.actionItem.textElement.map(
        (element) => (element.value = null)
      );

      // submenu off
      this.submenuOff();

      // focus
      this.focus();
    }
  },
};

export default ActionItem;